import { AUTHORIZE_CARD_REMOTE_PURCHASES_BUTTON_CLICK } from '../constants/analytics';
import { track } from './analytics';
export const setResendPendingInvitesAnalytics = (pendingInvitesNumber) => {
    track(AUTHORIZE_CARD_REMOTE_PURCHASES_BUTTON_CLICK, {
        section: 'card',
        actionType: `resend text2confirm invite: ${pendingInvitesNumber}`,
    });
};
